module.exports = __webpack_public_path__ + "media/images/flags/32/Palau-1a32a35553113ea22d9304ece0b7c346.png";